import React from 'react';
import MigrateTab from '../MigrateTab';

export const COLUMN_HEADERS_DISABLED = [
    { key: 'total', label: 'Total Inventario', value: 'allPropertiesCount' },
    { key: 'inactive', label: 'Inventario activo ultima vez ', value: 'inactivePropertiesCount' },
    { key: 'email', label: 'Correo electrónico', value: 'email' },
    { key: 'user_phone', label: 'Numero de telefono', value: 'user_phone' },
    { key: 'inactive', label: 'Fecha de ultima vez activo ', value: 'inactivePropertiesDate' },
    { key: "full_name", label: "Nombre", value: "full_name" },
    { key: "feed_name", label: "Nombre del feed", value: "feed_name" },
    { key: 'actions', label: 'Acciones', value: 'actions' },
];

const MigrateActive = (props) => {
    return <MigrateTab 
        columnHeaders={COLUMN_HEADERS_DISABLED}
        type="disabled"
        activeTab={props.activeTab}    
    />;
}

export default MigrateActive;